/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CommentRectIcon24Solid = forwardRef('CommentRectIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M6 3a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4v2.04c0 1.229 1.396 1.936 2.387 1.21L12.818 19H18a4 4 0 0 0 4-4V7a4 4 0 0 0-4-4H6Z" })));
});
